var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var AsyncBehaviorSubject = /** @class */ (function (_super) {
    __extends(AsyncBehaviorSubject, _super);
    function AsyncBehaviorSubject(defaultValue) {
        return _super.call(this, defaultValue) || this;
    }
    AsyncBehaviorSubject.prototype.next = function (value) {
        var _this = this;
        setTimeout(function () { return _super.prototype.next.call(_this, value); }, 0);
    };
    return AsyncBehaviorSubject;
}(BehaviorSubject));
export { AsyncBehaviorSubject };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/extensions/rxjs/async.behavior.subject.ts.pre-build-optimizer.js